import queryString from 'query-string';
import NewDownload from 'src/adminPanel/entities/office/downloadManagement/NewDownload';
import NewDownloadCategory from 'src/adminPanel/entities/office/downloadManagement/NewDownloadCategory';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult, RequestHeaders } from '.';

export const fetchDownloadCategory = (): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadCategory';
    return callApi(endpoint);
};

export const createDownloadCategory = (newDownloadCategory: NewDownloadCategory): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadCategory';
    return callApi(endpoint, { method: 'POST', data: newDownloadCategory });
};

export const editDownloadCategory = (newDownloadCategory: NewDownloadCategory): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadCategory';
    return callApi(endpoint, { method: 'PUT', data: newDownloadCategory });
};

export const deleteDownloadCategory = (downloadCategoryId: string): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadCategory/' + downloadCategoryId;
    return callApi(endpoint, { method: 'DELETE' });
};

export const fetchDownload = (
    downloadCategoryNormalizedName: string,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let requestHeaders: RequestHeaders;
    requestHeaders = { downloadCategoryNormalizedName };

    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/download/admin/download${query}`;
    return callApi(endpoint, { headers: requestHeaders });
};

export const createDownload = (newDownload: NewDownload): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/download';
    return callApi(endpoint, { method: 'POST', data: newDownload });
};

export const updateDownload = (newDownload: NewDownload): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/download';
    return callApi(endpoint, { method: 'PUT', data: newDownload });
};

export const deleteDownload = (downloadId: string): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/download/' + downloadId;
    return callApi(endpoint, { method: 'DELETE' });
};

export const fetchDownloadLanguage = (): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadLanguage';
    return callApi(endpoint);
};

export const createDownloadLanguage = (
    downloadId: string,
    languageIso2: string,
    file: any,
    countryIso2?: string
): Promise<CallApiResult> => {
    const formData = new FormData();
    formData.append('file', file);

    let requestHeaders: RequestHeaders;
    if (!countryIso2) {
        requestHeaders = { downloadId, languageIso2 };
    } else {
        requestHeaders = { downloadId, languageIso2, countryIso2 };
    }

    const endpoint = '/api/download/admin/downloadLanguage';
    return callApi(endpoint, { method: 'POST', headers: requestHeaders, data: formData });
};

export const deleteDownloadLanguage = (downloadLanguageId: string): Promise<CallApiResult> => {
    const endpoint = '/api/download/admin/downloadLanguage/' + downloadLanguageId;
    return callApi(endpoint, { method: 'DELETE' });
};
